import { useEffect, useRef } from 'react';

export const SUNDAY_WEEKDAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
export const MONDAY_WEEKDAYS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

export const SUNDAY_WEEKDAYS_LONG = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const MONDAY_WEEKDAYS_LONG = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const getMonthStart = (date) => new Date(date.getFullYear(), date.getMonth(), 1);

export const savedMonthStart = (savedDate, fallback) => {
  const parsed = savedDate ? new Date(savedDate) : null;
  return getMonthStart(parsed && !Number.isNaN(parsed.getTime()) ? parsed : fallback);
};

export const useSaveMonthOnChange = (currentMonth, onMonthChange) => {
  const isFirstMonth = useRef(true);

  useEffect(() => {
    if (isFirstMonth.current) {
      isFirstMonth.current = false;
      return;
    }
    if (onMonthChange) onMonthChange(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1, 12));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMonth]);
};

export const parseISODate = (isoDate) => {
  const [y, m, d] = isoDate.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const useGoToDate = (goToDate, onGoTo) => {
  const latestOnGoTo = useRef(onGoTo);
  latestOnGoTo.current = onGoTo;

  useEffect(() => {
    if (goToDate) latestOnGoTo.current(parseISODate(goToDate.date));
  }, [goToDate]);
};

export const getMonthEnd = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);

export const getDisplayRange = (monthDate, weekStartDay = 0) => {
  const monthStart = getMonthStart(monthDate);
  const monthEnd = getMonthEnd(monthDate);
  const displayStart = new Date(monthStart);
  const startOffset = (monthStart.getDay() - weekStartDay + 7) % 7;
  displayStart.setDate(displayStart.getDate() - startOffset);
  const displayEnd = new Date(monthEnd);
  const endOffset = (6 - ((monthEnd.getDay() - weekStartDay + 7) % 7));
  displayEnd.setDate(displayEnd.getDate() + endOffset);
  return { displayStart, displayEnd, monthStart, monthEnd };
};

export const toISODateString = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const isSameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const formatMonthYear = (date) =>
  date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
